/**
 * Sentinel answer value marking a required question as "no answer can be found in this paper".
 * Mirrors ExtractionAnswerValues.SKIPPED on the backend; flows through save/load/resolve as a
 * plain answer string. Counts as answered and needs no evidence annotation.
 */
export const SKIPPED_VALUE = '__SKIPPED__';

/** One answer row: the value for a single question in a submission. */
export interface AnswerRow {
  questionId: number;
  /** Encoded value: see plan header for encoding by QuestionType. */
  value: string;
}

/** Snapshot of all answer rows for a paper, keyed by paperToProjectId. */
export type AnswerSnapshot = AnswerRow[];
